<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <h4 class="title">Geo JSON Parameters</h4>
        <div class="close" v-on:click="close(false)"></div>
        <div class="roleCnt">
          <div class="roleItem">
            <h4>title[id]</h4>
            <p>For popup dialog's title in Bahasa Indonesia language</p>
          </div>
          <div class="roleItem">
            <h4>title[en]</h4>
            <p>For popup dialog's title in English language</p>
          </div>
          <div class="roleItem">
            <h4>descriptions[id]</h4>
            <p>Popup dialog's descriptions in Bahasa Indonesia.</p>
          </div>
          <div class="roleItem">
            <h4>descriptions[en]</h4>
            <p>Popup dialog's descriptions in English.</p>
          </div>
          <div class="roleItem">
            <h4>image[id]</h4>
            <p>Image url, image will be displayed for Bahasa Indonesia.</p>
          </div>
          <div class="roleItem">
            <h4>image[en]</h4>
            <p>Image url, image will be displayed for English.</p>
          </div>
          <div class="roleItem">
            <h4>url</h4>
            <p>If url are provided a button will be displayed.</p>
          </div>
          <div class="roleItem">
            <h4>button-label[id]</h4>
            <p>Button label in Bahasa Indonesia.</p>
          </div>
          <div class="roleItem">
            <h4>button-label[en]</h4>
            <p>Button label in English.</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      next: null,
      d: null,
    };
  },
  methods: {
    open(d, n) {
      this.show = true;
      this.d = d;
      this.next = n;
    },
    close(b, v) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, v);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.modal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
    opacity: 1;
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    width: 420px;
    margin: auto;
    border-radius: 5px;
    padding: 20px 0 10px;
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    h4{
      font-size: 24px;
      font-weight: 600;
      margin: 0 40px 10px;
    }
    .roleCnt{
      max-height: 68vh;
      overflow: auto;
      border-top: #eee 1px solid;
      border-bottom: #eee 1px solid;
      padding: 8px 0;
      box-sizing: border-box;
    }
    .roleItem{
      padding: 10px 40px;
      // cursor: pointer;
      margin: 0 0 4px;
      &:hover{
        // background-color: #f5f5fe;
      }
      &.selected{
        background-color: #f5f5f5;
      }
      h4{
        font-size: 18px;
        margin: 0 0 4px;
      }
    }
  }
}
</style>
